import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import PrimaryActionButton
  from 'Views/Page/Content/Templates/TransitionsDashboardPage/TransitionsDashboardPage/TransitionsDashboardPageSection/TransitionsDashboardPageSectionPrimaryActionPicker/PrimaryActionButton';

const TransitionsDashboardPageSectionPrimaryActionPicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.source.name]: (
      <PrimaryActionButton resource={resource} />
    ),
  }, null);
};

TransitionsDashboardPageSectionPrimaryActionPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
TransitionsDashboardPageSectionPrimaryActionPicker.defaultProps = {};

export default TransitionsDashboardPageSectionPrimaryActionPicker;
